import { RoutingNode } from 'hooks/useRouteCalculator/routing-graph';
import urlPaths from 'static/constants/enums/urlPaths';

const membershipPurchaseCompletePageRouting: RoutingNode = {
    forwardEdges: [
        {
            destination: urlPaths.start,
            condition: () => true,
        },
    ],
    backwardEdges: [],
    forAllBackwardEdges: () => {
        return false;
    },
};

export default membershipPurchaseCompletePageRouting;
